import {FC} from "react";
import BentoInsightCard from "../BentoInsightCard";
import {buildInsightCardsFromMorningBrief} from "./morningBriefCards";
import type {MorningBrief} from "./intelligenceModels";

interface IProps {
    brief: MorningBrief;
}

const SEVERITY_MODIFIER: Record<string, string> = {
    positive: "par-brief-watch__item--positive",
    attention: "par-brief-watch__item--attention"
};

// Renders a Morning Brief the same way the Bento insight feed renders any other
// investigation: one full InsightCard per highlight (same header, tags,
// narrative, and colored action rows as the rest of the product), with the
// lower-priority watch list collapsed into a quiet strip so it doesn't compete
// with what actually needs the manager's attention today.
const IntelligenceMorningBrief: FC<IProps> = ({brief}) => {
    const highlightCards = buildInsightCardsFromMorningBrief(brief);
    const watchList = brief.watch_list ?? [];

    return (
        <div className="par-brief-feed">
            {highlightCards.map(({card, agent}) => (
                <BentoInsightCard key={card.id} card={card} agent={agent} />
            ))}

            {watchList.length > 0 && (
                <div className="par-brief-watch">
                    <span className="par-brief-watch__label">Also on your radar</span>
                    <div className="par-brief-watch__items">
                        {watchList.map((item, index) => (
                            <div
                                key={`${item.metric}-${index}`}
                                className={`par-brief-watch__item ${
                                    SEVERITY_MODIFIER[item.severity ?? "neutral"] ?? ""
                                }`}
                            >
                                <span className="par-brief-watch__metric">
                                    {item.metric}
                                </span>
                                {item.scope && (
                                    <span className="par-brief-watch__scope">
                                        {item.scope}
                                    </span>
                                )}
                                <span className="par-brief-watch__value">
                                    {item.value}
                                </span>
                                {item.movement && (
                                    <span className="par-brief-watch__movement">
                                        {item.movement}
                                    </span>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default IntelligenceMorningBrief;
